var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "analysisUser" }, [
    _c(
      "header",
      [
        _c(
          "el-select",
          {
            staticClass: "gender",
            attrs: {
              placeholder: _vm.$t("Analysis.User.select_gender"),
              size: "small",
              multiple: "",
            },
            model: {
              value: _vm.params.genders,
              callback: function ($$v) {
                _vm.$set(_vm.params, "genders", $$v)
              },
              expression: "params.genders",
            },
          },
          _vm._l(_vm.genders, function (gender) {
            return _c("el-option", {
              key: gender.value,
              attrs: { label: gender.label, value: gender.value },
            })
          }),
          1
        ),
        _c(
          "el-select",
          {
            staticClass: "age",
            attrs: {
              placeholder: _vm.$t("Analysis.User.select_age"),
              size: "small",
              multiple: "",
            },
            model: {
              value: _vm.params.ages,
              callback: function ($$v) {
                _vm.$set(_vm.params, "ages", $$v)
              },
              expression: "params.ages",
            },
          },
          _vm._l(_vm.ages, function (age) {
            return _c("el-option", {
              key: age.value,
              attrs: { label: age.label, value: age.value },
            })
          }),
          1
        ),
        _c("el-date-picker", {
          staticClass: "picker",
          attrs: {
            type: "daterange",
            size: "small",
            align: "right",
            "unlink-panels": "",
            "range-separator": "〜",
            "start-placeholder": _vm.$t("Analysis.start_date"),
            "end-placeholder": _vm.$t("Analysis.end_date"),
            "picker-options": _vm.options,
            "value-format": "yyyy-MM-dd",
          },
          model: {
            value: _vm.params.daterange,
            callback: function ($$v) {
              _vm.$set(_vm.params, "daterange", $$v)
            },
            expression: "params.daterange",
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      { attrs: { id: "graphs" } },
      [
        _c(
          "div",
          { staticClass: "total-graph" },
          [
            _c("h1", [_vm._v(_vm._s(_vm.$t("Analysis.User.title03")))]),
            _c("Total", {
              attrs: {
                id: "totalGraph",
                height: 300,
                userAccessByDay: _vm.api.userAccessByDay,
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "gender-age-graph" }, [
          _c("h1", [_vm._v(_vm._s(_vm.$t("Analysis.User.title04")))]),
          _c("div", { staticClass: "graphs" }, [
            _c(
              "section",
              [
                _vm.checkEmpty()
                  ? _c("p", { staticClass: "none" }, [
                      _vm._v(_vm._s(_vm.$t("Dashboard.none_data"))),
                    ])
                  : _vm._e(),
                _c("Gender", {
                  attrs: {
                    id: "genderGraph",
                    height: 240,
                    userAccessByGenderAndAge: _vm.api.userAccessByGenderAndAge,
                  },
                }),
              ],
              1
            ),
            _c(
              "section",
              [
                _c("Age", {
                  attrs: {
                    id: "ageGraph",
                    height: 240,
                    userAccessByGenderAndAge: _vm.api.userAccessByGenderAndAge,
                    ages: _vm.params.ages,
                    age_settings: _vm.ages,
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "gender-rate-graph" },
          [
            _c("h1", [_vm._v(_vm._s(_vm.$t("Analysis.User.title05")))]),
            _c("Rate", {
              attrs: {
                id: "rateGraph",
                height: 280,
                userAccessByDay: _vm.api.userAccessByDay,
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "byage-graph" },
          [
            _c("h1", [_vm._v(_vm._s(_vm.$t("Analysis.User.title06")))]),
            _c("ByAge", {
              attrs: {
                id: "byAgeGraph",
                height: 300,
                userAccessByDay: _vm.api.userAccessByDay,
              },
            }),
          ],
          1
        ),
        _c("UserList", {
          attrs: {
            ages: _vm.params.ages,
            genders: _vm.params.genders,
            daterange: _vm.params.daterange,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }